'use es6';

import { isEqual } from 'underscore';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import React from 'react';
import I18n from 'I18n';
import { replace } from 'react-router-redux';
import AppHeader from '../components/AppHeader';
import UIListingPage from 'UIComponents/page/UIListingPage';
import DirectoryPage from '../components/DirectoryPage';
import SearchBarContainer from './SearchBarContainer';
import GoodSubTypes from '../constants/GoodSubTypes';
import GoodSubTypeGroups from '../constants/GoodSubTypeGroups';
import HeaderTabs from '../constants/HeaderTabs';
import GoodFiltersAndPage from '../constants/GoodFiltersAndPage';
import { getGoodsWithFilterAndPageParamsFromUrl, updatePage, updateGoodFilters } from '../actions/GoodsActions';
import { getQueryParamsWithParsedInt, parseQueryParamsForMultiselectFilters } from '../utils/utils';
import { Screens } from '../lib/usage/constants';
import withUsageTracking from './hocs/withUsageTracking';
import { compose } from 'redux';
var DirectoryContainer = createReactClass({
  displayName: "DirectoryContainer",
  propTypes: {
    auth: PropTypes.object.isRequired,
    categoryFilter: PropTypes.string.isRequired,
    directoryData: PropTypes.object.isRequired,
    getGoodsWithFilterAndPageParamsFromUrl: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    replace: PropTypes.func.isRequired,
    trackAdjustedFilter: PropTypes.func.isRequired,
    trackClickedLink: PropTypes.func.isRequired,
    trackPageview: PropTypes.func.isRequired,
    updatePage: PropTypes.func.isRequired,
    updateGoodFilters: PropTypes.func.isRequired
  },
  componentDidMount: function componentDidMount() {
    var location = this.props.location;
    var query = location.query;
    document.title = I18n.text('MarketplaceUI.directory.documentTitle');

    if (query.subType === GoodSubTypeGroups.PAGE_TEMPLATES) {
      this.props.replace(Object.assign({}, location, {
        query: Object.assign({}, query, {
          subType: GoodSubTypes.SITE_PAGES
        })
      }));
      return;
    }

    this.props.getGoodsWithFilterAndPageParamsFromUrl(parseQueryParamsForMultiselectFilters(getQueryParamsWithParsedInt(query)), true, "directory-" + (query.subType || 'all-categories'));
    this.props.trackPageview(Screens.DIRECTORY);
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    var currentQuery = this.props.location.query;
    var prevQuery = prevProps.location.query;

    if (!isEqual(currentQuery, prevQuery)) {
      this.props.getGoodsWithFilterAndPageParamsFromUrl(parseQueryParamsForMultiselectFilters(getQueryParamsWithParsedInt(currentQuery)), currentQuery.subType !== prevQuery.subType);
    }
  },
  adjustPageForZeroIndexing: function adjustPageForZeroIndexing(page) {
    return page - 1;
  },
  onPageChange: function onPageChange(evt) {
    this.props.updatePage(this.adjustPageForZeroIndexing(evt.target.value));
    window.scrollTo(0, 0);
  },
  resetPageToZero: function resetPageToZero(newFilteringParams) {
    newFilteringParams.page = 0;
    return newFilteringParams;
  },
  onGoodFilterChange: function onGoodFilterChange(newFilteringParams) {
    this.props.updateGoodFilters(this.resetPageToZero(newFilteringParams));
  },
  trackDirectoryPageLinkClick: function trackDirectoryPageLinkClick(itemClicked) {
    this.props.trackClickedLink(Screens.DIRECTORY, itemClicked);
  },
  trackDirectoryAdjustedFilter: function trackDirectoryAdjustedFilter(filterType, value) {
    this.props.trackAdjustedFilter(Screens.DIRECTORY, filterType, value);
  },
  render: function render() {
    var _this$props = this.props,
        auth = _this$props.auth,
        directoryData = _this$props.directoryData,
        location = _this$props.location,
        categoryFilter = _this$props.categoryFilter;
    return React.createElement(UIListingPage, {
      headerComponent: React.createElement(AppHeader, {
        currentTab: HeaderTabs.STOREFRONT,
        searchBarComponent: React.createElement(SearchBarContainer, {
          appliedSearchTerm: location.query.searchTerm || '',
          screen: "directory",
          categoryFilter: categoryFilter
        })
      }),
      pageLayout: "full-width",
      "data-selenium-selector": "directory-container"
    }, React.createElement(DirectoryPage, {
      auth: auth,
      directoryData: directoryData,
      onPageChange: this.onPageChange,
      onGoodFilterChange: this.onGoodFilterChange,
      trackAdjustedFilter: this.trackDirectoryAdjustedFilter,
      trackLinkClick: this.trackDirectoryPageLinkClick,
      categoryFilter: categoryFilter
    }));
  }
});

function mapStateToProps(state) {
  return {
    auth: state.auth,
    directoryData: state.directoryData,
    categoryFilter: state.directoryData.getIn(['goodFiltersAndPage', GoodFiltersAndPage.SUB_TYPE])
  };
}

var mapDispatchToProps = {
  getGoodsWithFilterAndPageParamsFromUrl: getGoodsWithFilterAndPageParamsFromUrl,
  updatePage: updatePage,
  updateGoodFilters: updateGoodFilters,
  replace: replace
};
export default compose(withUsageTracking(), connect(mapStateToProps, mapDispatchToProps))(DirectoryContainer);